import { render } from "./jobs.vue?vue&type=template&id=74559a6c&scoped=true"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"

import "./jobs.vue?vue&type=style&index=0&id=74559a6c&scoped=true&lang=css"

import exportComponent from "D:\\boya_project\\boya_web_mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74559a6c"]])

export default __exports__